import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { AccountsTokenService } from './accounts-token.service';

@Injectable({
  providedIn: 'root',
})

export class AccountsAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: AccountsTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}